import { Stack, Typography } from "@mui/material";
import { useQueryClient } from "@tanstack/react-query";
import { Button, InfoIcon } from "components";
import { useTestEmailConnection } from "controller";
import { useState } from "react";
import toast from "react-hot-toast";

export const TestEmailConnection = ({
  mappingId,
  setIsTestEmailConnectionSuccess,
}: {
  mappingId: string;
  setIsTestEmailConnectionSuccess: (value: boolean) => void;
}) => {
  const queryClient = useQueryClient();
  const {
    isFetching: isGetTestEmailConnectionFetching,
    refetch: refetchGetTestEmailConnection,
  } = useTestEmailConnection(mappingId);

  const [isShowErrorMsg, setIsShowErrorMsg] = useState(false);

  const onTestEmailConnectionSuccess = () => {
    setIsTestEmailConnectionSuccess(true);
    setIsShowErrorMsg(false);
    queryClient.invalidateQueries(["channel", "emails"]);
    toast.success("Email connection tested successfully");
  };
  const onTestEmailConnectionFailure = () => {
    setIsTestEmailConnectionSuccess(false);
    setIsShowErrorMsg(true);
    toast.error("Email connection failed");
  };

  const testEmailConnection = async () => {
    if (mappingId) {
      try {
        const response = await refetchGetTestEmailConnection();
        const resData = response?.data;
        if (resData?.deliveryTest) {
          onTestEmailConnectionSuccess();
        } else {
          onTestEmailConnectionFailure();
        }
      } catch (error) {
        onTestEmailConnectionFailure();
      }
    }
  };

  return (
    <Stack p="24px" gap="16px" borderRadius="8px" bgcolor="neutral.main">
      <>
        <Typography variant="body-medium" color="lightBg.low">
          Test your email configurations to proceed further
        </Typography>
        <Button
          variant="secondary"
          sx={{
            padding: "6px 24px",
            alignSelf: "flex-start",
          }}
          onClick={testEmailConnection}
          loading={isGetTestEmailConnectionFetching}
        >
          {isGetTestEmailConnectionFetching
            ? "Testing Connection"
            : "Test Connection"}
        </Button>
      </>
      {isShowErrorMsg && (
        <Stack
          direction="row"
          alignItems={"center"}
          justifyContent={"flex-start"}
          borderRadius="4px"
          p="8px"
          gap="8px"
          bgcolor={"error.tint"}
        >
          <InfoIcon
            color="error"
            sx={{
              width: "16px",
              height: "16px",
            }}
          />
          <Typography variant="caption-2" color="error.main">
            Email connection failed
          </Typography>
        </Stack>
      )}
    </Stack>
  );
};
